// extracted by mini-css-extract-plugin
export var container = "landing-page-module--container--f8df7";
export var description = "landing-page-module--description--30c7d";
export var heading = "landing-page-module--heading--05979";